module.exports = __webpack_public_path__ + "9f2e0e5df5e06560f9c2d4090a756f50.svg";